import { SPARTAN_ENGINE_SECTION_ANCHORS } from '@/app/lcv/components/sections/spartan/engine/shared/section-anchors';
import { SPARTAN_HOME_SECTION_ANCHORS } from '@/app/lcv/components/sections/spartan/home/shared/section-anchors';
import { SPARTAN_PRODUCT_SECTION_ANCHORS } from '@/app/lcv/components/sections/spartan/products/shared/section-anchors';
import { SPARTAN_SCROLL_TO_SECTION_OFFSET_PX } from '@/app/lcv/components/sections/spartan/shared/scroll-to-section/constants';

const SPARTAN_SECTION_ANCHOR_IDS = Array.from(
  new Set([
    ...Object.values(SPARTAN_PRODUCT_SECTION_ANCHORS),
    ...Object.values(SPARTAN_HOME_SECTION_ANCHORS),
    ...Object.values(SPARTAN_ENGINE_SECTION_ANCHORS),
  ])
);

export const SPARTAN_SECTION_SCROLL_MARGIN_CSS = `${SPARTAN_SECTION_ANCHOR_IDS.map(
  (id) => `#${id}`
).join(',')}{scroll-margin-top:${SPARTAN_SCROLL_TO_SECTION_OFFSET_PX}px}`;
